module.exports = __webpack_public_path__ + "img/marker-small.731a37b2.png";